/**
 * Router-state contract for handing a dropped image from the /search sidebar
 * to the start page's Upload & Match flow (CX-3746).
 */
export const UPLOADED_FILE_STATE_KEY = "uploadedFile";

/** Reads the handed-over image from router state; anything but a `File` is ignored. */
export function readHandoffFile(state: unknown): File | null {
  if (!state || typeof state !== "object") {
    return null;
  }
  const value = (state as Record<string, unknown>)[UPLOADED_FILE_STATE_KEY];
  return value instanceof File ? value : null;
}

/** Router state with the handed-over image removed, other keys preserved. */
export function withoutHandoffFile(state: unknown): Record<string, unknown> {
  if (!state || typeof state !== "object") {
    return {};
  }
  const { [UPLOADED_FILE_STATE_KEY]: _file, ...rest } = state as Record<
    string,
    unknown
  >;
  return rest;
}
